import { useQuery } from "@tanstack/react-query";
import { boronClient } from "../../../../api";
import { PaidServiceName } from "../../../../domains/PaidService";
import { createError } from "../../../../errors";
import { useQueryError } from "../../../../hooks/http/useQueryError";

import type { components } from "../../../../lib/api/v1";

export type PaidServiceAvailabilityStatus =
  components["schemas"]["PaidServiceAvailability"]["status"];

export type PaidServiceAvailability = {
  id: number;
  name: PaidServiceName;
  status: PaidServiceAvailabilityStatus;
};

type Props = {
  sectionId: string;
  studentId: string;
  enabled?: boolean;
};

export const useFetchPaidServiceAvailabilities = ({
  sectionId,
  studentId,
  enabled = true,
}: Props) => {
  const result = useQuery<PaidServiceAvailability[]>({
    queryKey: [
      `/api/v1/sections/${sectionId}/students/${studentId}/paid_service_availabilities`,
    ],
    queryFn: async () => {
      const { response, data } = await boronClient.GET(
        "/api/v1/sections/{section_id}/students/{student_id}/paid_service_availabilities",
        {
          params: {
            path: {
              section_id: sectionId,
              student_id: studentId,
            },
          },
        },
      );

      if (response.ok && data) {
        return data.paidServices;
      }
      throw await createError(response);
    },
    enabled,
  });

  useQueryError(result.error);

  return result;
};
